export const GET_ARTICLE_DETAIL = 'detail/GET_ARTICLE_DETAIL'
export const INIT_ARTICLE_DETAIL = 'detail/INIT_ARTICLE_LIST'
export const GET_COMMENT_LIST = 'detail/GET_COMMENT_LIST'
export const INIT_COMMENT_LIST = 'detail/INIT_COMMENT_LIST'
export const HANDLE_COMMENT_CHANGE = 'detail/HANDLE_COMMENT_CHANGE'
export const HANDLE_SUBMIT_COMMENT = 'detail/HANDLE_SUBMIT_COMMENT'
export const HANDLE_CONCAT_COMMENT = 'detail/HANDLE_CONCAT_COMMENT'
export const RESET_ARTICLE_DETAIL = 'detail/INIT_ARTICLE_DETAIL'
export const RESET_COMMENT_LIST = 'detail/INIT_COMMENT_LIST'
export const TOGGLE_NAV = 'detail/TOGGLE_NAV'
export const TOGGLE_NAV_DETAIL = 'detail/TOGGLE_NAV_DETAIL'
export const ADD_NAV_LIST = 'detail/ADD_NAV_LIST'
export const ADD_NAV_INDEX = 'detail/ADD_NAV_INDEX'
export const RESET_NAV_INFO = 'detail/RESET_NAV_INFO'
